/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable react/jsx-no-comment-textnodes */
import i18next from 'i18next';
import { connect } from "react-redux";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import React, { useEffect, useMemo, useState } from "react";
import { SelectFilters, Header, SearchFilters } from 'datastake-daf/dist/components';

import Loading from "../../Loading";
import NotFound from "../../NotFound";
import Styles from '../locations/style';
import { PROJECTS } from '../../../helpers/CanAccess';
import { useFilters } from "../../../helpers/SubjectSearch";
import { actions as projectActions } from '../../../store/reducers/project';
import { getHeaderColumns, selectFiltersConfig, filtersConfig, checkboxConfig, selectOptions, mstp } from './config';
import { renderBreadCrumbs } from '../../../helpers/breadCrumbs';
import DafTable from '../../Table/newTable';

function DueDiligence({
  authentication: { user, selectedProject, sourceId },
  project: { reports = [] },
  CaddReportsGet,
  module = "cadd"
}) {
  const goTo = useNavigate();
  const { t } = useTranslation();
  const [expandedRows, setExpandedRows] = useState([]);
  const [showFilters, setShowFilters] = useState(false);
  const [hasError, setHasError] = useState(false);
  const [filters, setFilters] = useState({ author: '' });

  const {
    newFiltersConfig,
    activeFilters,
    onSearch,
    defaultFilters,
    setActiveFilters,
  } = useFilters({
    selectFiltersConfig,
    module,
    filtersConfig,
    onTableChange: () => { },
  });

  const canClearSearch = useMemo(() => {
    return !!activeFilters.search;
  }, [activeFilters]);

  const dataSource = useMemo(() => {
    if (Array.isArray(reports)) {
      const d = reports.map((r, i) => {
        if (Array.isArray(r.children)) {
          return {
            ...r,
            key: `${r.name}-${r.dbId}-${r.version}-${i}`,
            children: r.children.map((ch, j) => ({
              ...ch,
              key: `${r.name}-${ch.dbId}-${ch.version}-${i}-${j}`,
            }))
          }
        }
        return {
          ...r,
          key: `${r.dbId}-${r.version}-${i}`,
        };
      })

      if (sourceId && sourceId !== 'overview') {
        return d.filter(d => d.authorId === sourceId);
      }

      return d;
    }
    return [];
  }, [reports, sourceId]);

  const _dataSource = useMemo(() => {
    return dataSource.filter((s) => {
      let searchValid = true;
      let filtersValid = true;

      if (typeof activeFilters?.search === 'string' && activeFilters?.search) {
        const _isValid = (s?.name || '').toLowerCase().indexOf(activeFilters.search.toLowerCase()) !== -1;
        searchValid = _isValid;
      }

      if (typeof filters?.author === 'string' && filters?.author) {
        const _isValid = (s?.author || '').toLowerCase().indexOf(filters.author.toLowerCase()) !== -1;
        filtersValid = _isValid;
      }

      return searchValid && filtersValid;
    });
  }, [dataSource, activeFilters, filters]);

  const HeaderColumns = getHeaderColumns(
    t,
    module,
    goTo,
    (reports && expandedRows) ? expandedRows.map((e) => _dataSource.find((r) => r.key === e)) : [],
  );
  const [Columns, setColumns] = useState(HeaderColumns.filter(column => column.show) || []);

  useEffect(() => {
    setColumns(HeaderColumns.filter(column => column.show) || []);
  }, [expandedRows])

  useEffect(() => {
    if (selectedProject !== PROJECTS.myData) {
      CaddReportsGet({ id: selectedProject, userId: user?.company?.id, query: { view: 'due-diligence' } });
    }
  }, [selectedProject, user.language, sourceId]);

  const data = {};

  const breadCrumbs = useMemo(() =>
    renderBreadCrumbs({ t, view: 'due-diligence', goTo, mod: module }), [t, goTo]);

  return selectedProject !== PROJECTS.myData ? (!data ? <Loading /> : (
    <Styles className="semibold form-input-output">
      <Header
        title={t("Due Diligence Documents")}
        breadcrumbs={breadCrumbs}
      />
      <div className="column start table-content">
        <div className='mt-6 ml-6 mr-6'>
          <SearchFilters
            t={t}
            showFilters={showFilters}
            setShowFilters={setShowFilters}
            hasError={hasError}
            setHasError={setHasError}
            filtersConfig={newFiltersConfig}
            checkboxConfig={checkboxConfig}
            onSearch={onSearch}
            activeFilters={activeFilters}
            canClear={canClearSearch}
            clearFilters={() => setActiveFilters({})}
          />
        </div>
        <SelectFilters
          language={i18next.language}
          t={t}
          options={selectOptions}
          filtersConfig={selectFiltersConfig}
          onApply={(_filters) => {
            setFilters(_filters);
          }}
          showFilters={showFilters}
          setShowFilters={setShowFilters}
          selectedFilters={defaultFilters}
        />
        <div className='daf-table-wrapper pagination-w-padding'>
          <DafTable
            className="mb-6"
            columns={Columns}
            expandable={{
              onExpandedRowsChange: (expanded) => setExpandedRows(expanded),
            }}
            onRow={({ id, children }) => {
              return {
                className: (expandedRows.includes(id) && children) ? 'expanded-row' : '',
              };
            }}
            dataSource={_dataSource}
            size="small"
            rowKey="key"
          />
        </div>
      </div>
    </Styles>
  )) : <NotFound />;
}


export default connect(mstp, projectActions)(DueDiligence);
